import { EmptyState, Text, WarningIcon } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

type CommentErrorStateProps = {
  /**
   * When set, renders the critical fetch-failure treatment with the message.
   * When absent, renders the softer "not available" treatment (deleted
   * comment, unknown id, or a channel the actor can't access).
   */
  errorMessage?: string
}

/**
 * The "comment could not be shown" presentation for the comment-details
 * dialog, mirroring PostErrorState's warning/critical split.
 */
export function CommentErrorState({
  errorMessage,
}: CommentErrorStateProps): JSX.Element {
  if (errorMessage === undefined) {
    return (
      <EmptyState variant="warning">
        <EmptyState.Icon>
          <WarningIcon />
        </EmptyState.Icon>
        <EmptyState.Heading>Comment not available</EmptyState.Heading>
        <EmptyState.Description>
          This comment may have been deleted, or it belongs to a channel you
          don&apos;t have access to.
        </EmptyState.Description>
      </EmptyState>
    )
  }

  return (
    <EmptyState variant="critical">
      <EmptyState.Icon>
        <WarningIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>Something went wrong</EmptyState.Heading>
      <EmptyState.Description>
        We couldn&apos;t load this comment, please try again.{' '}
        <Text color="critical">{errorMessage}</Text>
      </EmptyState.Description>
    </EmptyState>
  )
}
